module.exports = __webpack_public_path__ + "static/media/logo-x.97ed412c.svg";